<script setup lang="ts">
defineProps({
  source: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <a :href="source" class="text-light-underlined underline" target="_blank">
    {{ title }}
  </a>
</template>
